import React from 'react'

const ScaledOrder = () => {
  return (
    <div>
      
    </div>
  )
}

export default ScaledOrder
